import React from 'react';
import { PlaneIcon, DollarSignIcon, SmartphoneIcon, ShoppingBagIcon, UtensilsIcon, TruckIcon } from 'lucide-react';
export function ServicesGrid() {
  const services = [{
    icon: PlaneIcon,
    title: 'Vuelos',
    description: 'Reserva vuelos a Cuba'
  }, {
    icon: DollarSignIcon,
    title: 'Remesas',
    description: 'Envía dinero de forma segura'
  }, {
    icon: SmartphoneIcon,
    title: 'Recargas',
    description: 'Recarga móviles en Cuba'
  }, {
    icon: ShoppingBagIcon,
    title: 'Tienda',
    description: 'Productos para toda la familia'
  }, {
    icon: UtensilsIcon,
    title: 'Combos de comida en Cuba',
    description: 'Alimenta a tu familia',
    highlighted: true
  }, {
    icon: TruckIcon,
    title: 'Envíos',
    description: 'Entrega rápida y segura'
  }];
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="text-center mb-12" data-id="element-179">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-180">
            Nuestros Servicios
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-181">
            Todo lo que necesitas para mantener a tu familia conectada
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-182">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} className={`group p-8 rounded-xl transition-all duration-300 cursor-pointer ${service.highlighted ? 'bg-red-50 border-2 border-red-600 shadow-lg hover:shadow-xl' : 'bg-gray-50 hover:bg-white hover:shadow-lg'}`} data-id="element-183">
                <div className={`inline-flex p-4 rounded-lg mb-4 ${service.highlighted ? 'bg-red-600' : 'bg-blue-900'}`} data-id="element-184">
                  <Icon className="h-8 w-8 text-white" data-id="element-185" />
                </div>
                <h3 className={`text-xl font-semibold mb-2 ${service.highlighted ? 'text-red-600' : 'text-gray-900'}`} data-id="element-186">
                  {service.title}
                </h3>
                <p className="text-gray-600" data-id="element-187">{service.description}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}